import PlaceCard from './PlaceCard';
import useTripStore from '../../context/TripStore';

const PlaceList = () => {
  const { places } = useTripStore();

  if (places.length === 0) {
    return (
      <div className="border border-dashed border-gray-300 p-8 text-center">
        <p className="text-xs font-light text-gray-400">No places added yet. Search and add places to your list!</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h2 className="text-sm font-light mb-4 uppercase tracking-wide text-gray-600">
        Your List ({places.length} places)
      </h2>
      {places.map((place, index) => (
        <PlaceCard key={place.id} place={place} isInList={true} index={index + 1} />
      ))}
    </div>
  );
};

export default PlaceList;

